<template>
  <transition name="slide-fade">
    <div class="login">
      <main class="main">
        <transition name="slide-fade">
          <div v-if="localError" class="alert alert-danger col" role="alert">{{localError}}</div>
        </transition>

        <Loader v-if="loading"/>
      </main>
    </div>
  </transition>
</template>

<script>
import Loader from '@/components/elements/Loader'
export default {
  name: 'VerifyEmail',
  components: {
    Loader
  },
  data () {
    return {
      password: '',
      passwordConfirm: '',
      localError: null,
      loading: true
    }
  },
  mounted: function () {
    if (!this.token) {
      this.localError = 'Could not verify token'
      this.loading = false
    } else {
      this.$store
        .dispatch('postEmailVerification', this.token)
        .then(success => {
          console.log('success')
          this.$router.push('/login?fromVerify=1')
        })
        .catch(error => {
          console.log(error)
          this.localError = error.response.data.error
        })
    }
  },
  computed: {
    token: function () {
      return Object.keys(this.$route.query)[0]
    }
  }
}
</script>

<style scoped lang='scss'>
body {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/templates/VerifyEmail.vue